import { AsButton, Spacer, useModal } from '@adserve/adserve-react-components';
import React, { useState } from 'react';
import { inputStyle } from '../../../styles';
import AsTextarea from '../../generic/AsTextArea';

const headingStyle = {
    fontSize: 22,
    fontWeight: 500,
    color: '#414141',
    marginBottom: '5%'
};

const buttonStyle = {
    fontSize: 15
};

const ApprovalModal = ({ isApproving, onActionRequest }) => {
    const { removeMessage } = useModal();

    const [note, setNote] = useState();

    const handleNoteUpdate = (event) => {
        setNote(event.target.value);
    };

    const handleClose = () => {
        removeMessage();
    };

    const handleActionRequest = () => {
        typeof onActionRequest && onActionRequest(isApproving, note);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={headingStyle}>
                {window.translate(`Are you sure you wish to ${isApproving ? 'approve' : 'reject'} the request?`)}
            </span>
            <AsTextarea
                id='request-notes'
                name='note'
                inputStyle={{ ...inputStyle, height: 70 }}
                value={note}
                onChange={handleNoteUpdate}
            />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5%' }}>
                <AsButton
                    style={{ ...buttonStyle, width: '16%' }}
                    useTertiaryStyle
                    handleClick={handleClose}
                >
                    {window.translate('No')}
                </AsButton>
                <Spacer width={20} />
                <AsButton
                    style={{ ...buttonStyle, width: '24%' }}
                    handleClick={handleActionRequest}
                >
                    {window.translate('Yes')}
                </AsButton>
            </div>
        </div>
    );
};

export default ApprovalModal;
